import PropTypes from 'prop-types';
import React from 'react';
import { Typography } from '@material-ui/core';

const Heading = ({ content, variant }) => (
    <Typography variant={variant}>
        {content}
    </Typography>
);

export default Heading;

Heading.propTypes = {
    content: PropTypes.string,
    variant: PropTypes.string,
};

Heading.defaultProps = {
    content: 'Heading',
    variant: 'h1',
};
